export const convertToSlug = (text?: string) => {
  if (text) {
    return text.toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  } else return '-';
};
